"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ENTER: 13,
  ESC: 27,
  ESCAPE: 27,
  SPACE: 32,
  UP: 38,
  DOWN: 40
};


//////////////////
// WEBPACK FOOTER
// ./~/react-mdl-extra/lib/keycodes.js
// module id = 134
// module chunks = 0